/** @jsxImportSource @emotion/react */

import { headerLinks } from "../../../../actions/Tenants/config/constants";
import { UserRole } from "../../../../actions/Tenants/config/constantsTyped";
import FilterableConfigList from "./FilterableConfigList";


export const links = [
    { path: headerLinks.home, label: "Overview" },
    { path: headerLinks.settings, label: "Settings" },
    { path: headerLinks.logout, label: "Logout" },
    { path: headerLinks.insights, label: "Insights" },
    { path: headerLinks.labelling, label: "Labelling" },
    { path: headerLinks.packinglist, label: "Packing list" },
    { path: headerLinks.deviceManagement, label: "Device Management" },
    { path: headerLinks.tenants, label: "Tenants" },
    { path: headerLinks.ripening, label: "Ripening" },
    { path: headerLinks.waste, label: "Waste" },
    { path: headerLinks.mailbox, label: "Mailbox" },
    { path: headerLinks.admin, label: "Admin", description: "Admin UI for clients" },
    { path: headerLinks.sourcingList, label: "Sourcing List", description: "Sourcing list upload for orders and pallets" },
    { path: headerLinks.tabCategoryStock, label: "Stock", description: "Tab category Stock" },
    { path: headerLinks.tabCategoryQCPlanning, label: "QC", description: "Tab category QC Planning" },
    { path: headerLinks.tabCategoryQCReport, label: "Reports", description: "Tab category QC Reports" },
    { path: headerLinks.tabCategoryOperation, label: "Operation", description: "Tab category Operation" },
    { path: headerLinks.tabCategoryTransit, label: "Transit", description: "Tab category Transit" },
    { path: headerLinks.tabCategoryRipeningPlanning, label: "Ripening Planning", description: "Tab category Ripening Planning" },
    { path: headerLinks.tabCategoryA, label: "Category A", description: "Tab category A - rename as needed in Label" },
    { path: headerLinks.tabCategoryB, label: "Category B", description: "Tab category B - rename as needed in Label" },
    { path: headerLinks.tabCategoryC, label: "Category C", description: "Tab category C - rename as needed in Label" },
    { path: headerLinks.tabCategoryD, label: "Category D", description: "Tab category D - rename as needed in Label" },
    { path: headerLinks.signals, label: "Signals", description: "Signals" },
];

const defaultField = {
    field: {
        path: headerLinks.home,
        label: "Overview",
    },
    display_filter: {
        fruit_types: [],
        exclude_fruit_types: [],
        layer_types: [],
    // exclude_layer_types: [],
    }
};
export default function NavigationConfigForm({ name, title, fields, description, setArray }) {
    const getFieldTitle = (object) => <span>{object.label} [{object.path}]</span>;
    const getFieldForm = (_, setObject) => [
        {
            label: "Path",
            type: "single-select",
            name: "path",
            options: links.map((i) => ({ value: i.path, label: i.description || i.label })),
            onchange_callback: ({ value }) => {
                const urlOption = links.find((i) => i.path === value);
                if (urlOption) {
                    const { path, label } = urlOption;
                    setObject({ path, label });

                } else {
                    setObject({ path: null, label: "" });
                }
            }
        },
        {
            label: "Path addition",
            type: "text",
            name: "path_addition",
            description: "Additional path to append to the base path, e.g. '{workspace_id}/{report_id}'. This will be appended to the base URL.",
            placeholder: "my-custom-page",
        },
        {
            label: "Label",
            type: "text",
            name: "label",
        },
        {
            label: "Roles to display",
            description: "Roles that can see this link",
            type: "single-select",
            name: "roles",
            multi: true,
            return_array: true,
            options: [
                { value: UserRole.TENANT_ADMIN, label: "TenantAdmin" },
            ]
        },
        {
            label: "Display for teams",
            description: "Only show this tab for these teams.",
            multi: true,
            return_array: true,
            type: "select-managed",
            options_name: "teams",
            name: "teams",
        },

    ];
    return <FilterableConfigList
        name={name}
        title={title}
        description={description}
        fields={fields}
        setArray={setArray}
        defaultField={defaultField}
        getFieldForm={getFieldForm}
        getFieldTitle={getFieldTitle}
        useDisplayFilter={false}
    />;

}


